import { PlansActionFilter } from '../../api/types'

const PLANS_FILTER_EMPTY_STATE_ILLUSTRATION_SRC = '/images/allocation/plans-filter-empty-state.png'

function getPlansActionFilterEmptyMessage(actionFilter: PlansActionFilter): string {
  if (actionFilter === PlansActionFilter.SELL) {
    return 'No funds to sell'
  }
  if (actionFilter === PlansActionFilter.BUY) {
    return 'No funds to buy'
  }
  return 'No funds'
}

type PlansListFilterEmptyStateProps = {
  actionFilter: PlansActionFilter
}

export function PlansListFilterEmptyState({ actionFilter }: PlansListFilterEmptyStateProps) {
  return (
    <div className="bg-white px-5 pt-6 pb-12 h-[400px] flex items-center justify-center">
      <div className="flex flex-col items-center">
        <img
          src={PLANS_FILTER_EMPTY_STATE_ILLUSTRATION_SRC}
          alt=""
          className="mb-[-20px] h-[184px] w-[243px] object-contain"
        />
        <p className="max-w-[173px] text-center text-[13px] font-[400] leading-[150%] text-[#8E9393]">
          {getPlansActionFilterEmptyMessage(actionFilter)}
        </p>
      </div>
    </div>
  )
}
